import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import Alerts from './Alerts';
import AlertDetails from './Alerts/AlertDetails';
// import * as Sentry from '@sentry/react';
import Apps from './Apps';
import AppDatasheet from './Apps/AppDatasheet';
import Callback from './Callback';
import Cases from './Cases';
import CaseDetails from './Cases/CaseDetails';
import Dashboard from './Dashboard';
import DevDashboard from './Dev/Dashboard';
import ProfilePage from './Dev/Profile';
import RequestDevPage from './Dev/Request';
import Embed from './Embed';
import GetCyberEmbed from './Embed/GetCyber';
import StrevEmbed from './Embed/Strev';
import NotFound from './Error/NotFound';
import ErrorTest from './Error/Test';
import Files from './Files';
import CreateFile from './Files/CreateFile';
import Loading from './Loading';
import Nodes from './Nodes';
import Node from './Nodes/Node';
import NodeSource from './Nodes/NodeSource';
import Partner from './Partner';
import DataSheets from './Partner/DataSheets';
import EmbedForUrl from './Partner/Embed';
import Links from './Partner/Links';
import PartnerAccounts from './Partner/PartnerAccounts';
import Settings from './Settings';
import SettingsApiCredentials from './Settings/ApiCredentials';
import SettingsApiCredentialsDelete from './Settings/ApiCredentials/ApiCredentialsDelete';
import SettingsApiCredentialsDetails, {
  SettingsApiCredentialsDetailsNew
} from './Settings/ApiCredentials/ApiCredentialsDetails';
import BrandAppSettings from './Settings/BrandAppSettings';
import BrandSettings from './Settings/BrandSettings';
import Systems from './Systems';
import System from './Systems/System';
import SystemEntity from './Systems/SystemEntity';
import UserProfile from './UserProfile';

// const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
const SentryRoutes = Routes; // TODO fix this

const PageRoutes: React.FC = () => {
  return <>
    <SentryRoutes>
      <Route path='/' element={<Dashboard />} />
      <Route path='/academy' element={<Navigate to='/e/academy' />} />
      <Route path='/alerts' element={<Alerts />}>
        <Route path=':alertId' element={<AlertDetails />} />
      </Route>
      <Route path='/apps' element={<Apps />}>
        <Route path=':product' element={<AppDatasheet />} />
      </Route>
      <Route path='/callback' element={<Callback />} />
      <Route path='/cases' element={<Cases />}>
        <Route path=':caseId' element={<CaseDetails />} />
      </Route>
      <Route path='/dev/dashboard' element={<DevDashboard />} />
      <Route path='/dev/request' element={<RequestDevPage />} />
      <Route path='/dev/profile' element={<ProfilePage />} />
      <Route path='/dev/loading' element={<Loading />} />
      <Route path='/dev/error' element={<ErrorTest />} />
      <Route path='/e/:site' element={<Embed />} />
      <Route path='/eam' element={<StrevEmbed />} />
      <Route path='/files' element={<Files />}>
        <Route path='upload' element={<CreateFile />} />
      </Route>
      <Route path='/grc' element={<GetCyberEmbed />} />
      <Route path='/nodes' element={<Nodes />} />
      <Route path='/nodes/:nodeId/:tableName?' element={<NodeSource />}>
        <Route path=':entityId' element={<Node />} />
      </Route>
      <Route path='/partner' element={<Partner />}>
        <Route index element={<Navigate to='datasheets' />} />
        <Route path='academy' element={EmbedForUrl('{middleAuth}/saml/bd1116c0-9f9b-47f5-a8ef-1c4843e0db75/auth?token={portalToken}')} />
        <Route path='accounts' element={<PartnerAccounts />} />
        <Route path='datasheets' element={<DataSheets />}>
          <Route path=':product' element={<AppDatasheet />} />
        </Route>
        <Route path='links' element={<Links />} />
        <Route path='marketing-hub' element={EmbedForUrl('https://whitedogcyber.saleshood.com/my/public/sites/3593870oX5pmPiFMeGhLtFMpybw1758047880?ref=copy_link')} />
      </Route>
      <Route path='/profile' element={<UserProfile />} />
      <Route path='/settings' element={<Settings />}>
        <Route index element={<Navigate to='brand' />} />
        <Route path='api-credentials' element={<SettingsApiCredentials />}>
          <Route path='new' element={<SettingsApiCredentialsDetailsNew />} />
          <Route path=':credentialId' element={<SettingsApiCredentialsDetails />}>
            <Route path='delete' element={<SettingsApiCredentialsDelete />} />
          </Route>
        </Route>
        <Route path='brand' element={<BrandSettings />} />
        <Route path='brand_apps' element={<BrandAppSettings />} />
      </Route>
      <Route path='/systems' element={<Systems />} />
      <Route path='/systems/:systemId/:tableName?' element={<System />}>
        <Route path=':entityId' element={<SystemEntity />} />
      </Route>

      <Route path='*' element={<NotFound />} />
    </SentryRoutes>
  </>;
};

export default PageRoutes;
